import styled from 'styled-components'
import { COLORS } from 'consts/colors'
import { MOBILE_SIZE_BREAKPOINT, SMALL_MOBILE_SIZE_BREAKPOINT } from 'consts'

export const CanvasContainer = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: ${COLORS.primaryLight};
  padding: 50px 30px 30px;
  box-sizing: border-box;
  //canvas scalling start breakpoint
  @media (max-width: ${1470}px) {
    padding: 15px 30px 15px;
  }
  @media (max-width: ${MOBILE_SIZE_BREAKPOINT}px) {
    padding: 40px 20px 20px;
  }
  @media (max-width: ${SMALL_MOBILE_SIZE_BREAKPOINT}px) {
    padding: 40px 10px 18px;
  }
`

export const ResizableWrapper = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const CanvasWrapper = styled.div<{
  $aspectRatio: number
  $isBlankCanvas?: boolean
}>`
  position: relative;
  aspect-ratio: ${({ $aspectRatio }) => $aspectRatio};
  max-width: 100%;
  max-height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
`

export const ProjectDuration = styled.span`
  position: absolute;
  bottom: 2px;
  right: 10px;
  border-radius: 5px;
  z-index: 1;
  font-size: 12px;
  font-weight: 500;
  color: ${COLORS.secondarySemiDark};
`
